import IApiCommand from './IApiCommand';
class ApiCommandHandler {
  public async runCommand<T = never>(command: IApiCommand<T>): Promise<T | null> {
    return new Promise<T | null>((resolve, reject) => {
      command
        .runCommand()
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default ApiCommandHandler;
